import { hydrateCart } from '../actions';
import { loadCartFromStorage } from '../storage';
import { TCartThunkDispatch } from '../types';

export const hydrateCartFromStorage = () => (dispatch: TCartThunkDispatch) => {
    const storedCart = loadCartFromStorage();

    if (storedCart) {
        dispatch(hydrateCart({ ...storedCart, isHydrated: true }));
        return;
    }

    dispatch(hydrateCart({ localCartId: null, items: [], isHydrated: true }));
};
